/**
 * Narrow-hit tipleri + object collision event sabiti. SugarModel içermez —
 * `dragCollisionDebugDraw` ↔ `ObstacleCollision` döngüsünü kırar.
 */

import type { Scene, Vector3 } from "three";
import { OBB } from "three/examples/jsm/math/OBB.js";
import type { Line } from "../../../shape/Line";

export type ObstacleKind = "model" | "wall";

export interface Obstacle {
  kind: ObstacleKind;
  obb: OBB;
  line?: Line;
  /** Model uuid + parça sırası, ya da duvar adı. OBB klonu her kare değişir. */
  latchKey: string;
  /** Plan duvarının oda içine bakan normali. İtme bunu okumaz; yalnız yaw. */
  faceNormal?: Vector3;
}

/** Bir temas: köşeden kenar ayağına dik çizgi. */
export interface SeparationDebug {
  from: Vector3;
  to: Vector3;
  depth: number;
  chosen: boolean;
  cornerOwner: "dragged" | "obstacle";
  obstacleKey: string;
}

/** O karede sürüklenene yazılan öteleme. */
export interface AppliedPushDebug {
  from: Vector3;
  to: Vector3;
}

/** Köşe çizgisi hizası. ContactApi itmesi değil. */
export interface CornerLineSnapDebug {
  from: Vector3;
  to: Vector3;
  chosen: boolean;
  axis: "right" | "forward";
}

export interface NarrowHit {
  selfObb: OBB;
  obstacle: Obstacle;
}

export const OBJECT_COLLISION_HITS = "object-collision-hits";

export type ObjectCollisionHitsDetail = {
  hits: NarrowHit[];
  scene?: Scene;
  separations?: SeparationDebug[];
  appliedPush?: AppliedPushDebug;
  /** Her katmanın kendi yeşil oku. */
  appliedPushes?: readonly AppliedPushDebug[];
  /** Köşe hizası adayları + kazanan. */
  cornerSnaps?: readonly CornerLineSnapDebug[];
};
